<app-system-page-layout>
  <ng-container header-title-controls>
    <button mat-raised-button class="accent_success" (click)="create()">
      <mat-icon>
        add
      </mat-icon>
      {{ 'generic.actions.createCity' | transloco }}
    </button>
  </ng-container>
  <ng-container content>
    <app-system-cities-list (tileClicked)="edit($event)"></app-system-cities-list>
  </ng-container>
</app-system-page-layout>
